// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");

function collectFromKeyValuePairs(kvs) {
  return Belt_Array.reduce(kvs, {
              type_: undefined,
              value: undefined,
              name: undefined,
              title: undefined,
              placeholder: undefined,
              selected: false,
              contenteditable: undefined
            }, (function (attributes, param) {
                var value = param[1];
                switch (param[0]) {
                  case "contenteditable" :
                      return {
                              type_: attributes.type_,
                              value: attributes.value,
                              name: attributes.name,
                              title: attributes.title,
                              placeholder: attributes.placeholder,
                              selected: attributes.selected,
                              contenteditable: Pervasives.bool_of_string(value)
                            };
                  case "name" :
                      return {
                              type_: attributes.type_,
                              value: attributes.value,
                              name: value,
                              title: attributes.title,
                              placeholder: attributes.placeholder,
                              selected: attributes.selected,
                              contenteditable: attributes.contenteditable
                            };
                  case "placeholder" :
                      return {
                              type_: attributes.type_,
                              value: attributes.value,
                              name: attributes.name,
                              title: attributes.title,
                              placeholder: value,
                              selected: attributes.selected,
                              contenteditable: attributes.contenteditable
                            };
                  case "selected" :
                      var tmp;
                      switch (value) {
                        case "false" :
                            tmp = false;
                            break;
                        case "" :
                        case "selected" :
                        case "true" :
                            tmp = true;
                            break;
                        default:
                          tmp = false;
                      }
                      return {
                              type_: attributes.type_,
                              value: attributes.value,
                              name: attributes.name,
                              title: attributes.title,
                              placeholder: attributes.placeholder,
                              selected: tmp,
                              contenteditable: attributes.contenteditable
                            };
                  case "title" :
                      return {
                              type_: attributes.type_,
                              value: attributes.value,
                              name: attributes.name,
                              title: value,
                              placeholder: attributes.placeholder,
                              selected: attributes.selected,
                              contenteditable: attributes.contenteditable
                            };
                  case "type" :
                      return {
                              type_: value,
                              value: attributes.value,
                              name: attributes.name,
                              title: attributes.title,
                              placeholder: attributes.placeholder,
                              selected: attributes.selected,
                              contenteditable: attributes.contenteditable
                            };
                  case "value" :
                      return {
                              type_: attributes.type_,
                              value: value,
                              name: attributes.name,
                              title: attributes.title,
                              placeholder: attributes.placeholder,
                              selected: attributes.selected,
                              contenteditable: attributes.contenteditable
                            };
                  default:
                    return attributes;
                }
              }));
}

function ofDomElement(domElement) {
  var attributes;
  try {
    attributes = Array.prototype.slice.call(domElement.attributes);
  }
  catch (exn){
    attributes = [];
  }
  return collectFromKeyValuePairs($$Array.map((function (domAttribute) {
                    var key = domAttribute.name;
                    var value = domAttribute.value;
                    return [
                            key,
                            value
                          ];
                  }), attributes));
}

function ofSelectorNode(param) {
  return collectFromKeyValuePairs(param.attributes);
}

exports.ofDomElement = ofDomElement;
exports.ofSelectorNode = ofSelectorNode;
/* No side effect */
